import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';

import i18n, { loadLanguageAsync } from '@/i18n';

// Directly import Home view for faster rendering of first page
import AccueilMaternite from '@/views/AccueilMaternite.vue';
import AffichageArticle from '@/views/AffichageArticle.vue';
import AccueilSanteEnfant from '@/views/AccueilSanteEnfant.vue';
import HomeSanteEnfant from '@/components/santeEnfant/HomeSanteEnfant.vue';
import { store } from './store';

Vue.use(Router);
Vue.use(Meta);

/** See https://router.vuejs.org/fr/essentials/navigation.html for help */
const router = new Router({
	mode: 'history', // Use the History API, and remove the hash from the URL
	routes: [
		{
			path: '/parcours-maternite/:dpg',
			name: 'home',
			component: AccueilMaternite,
			props: (route) => ({moisSel : route.query.moisSel, dpg : route.params.dpg})
		},
		{
			path: '/parcours-maternite/:dpg/calendrier',
			name: 'calendrier',
			component: () => import('./views/Calendrier.vue'),
			props: true
		},
		{
			path: '/parcours-maternite/:dpg/article/:id',
			name: 'article',
			component: AffichageArticle,
			props: (route) => ({id : route.params.id,  dpg : route.params.dpg, moisSel:route.query.moisSel})
		},
		{
			path: '/sante-enfant/:enfants',
			name: 'sante-enfant-accueil',
			component: AccueilSanteEnfant,
			props: (route) => ({jsonenfants : route.params.enfants})
		},
		{
			path: '/sante-enfant/:enfants/enfant/:id',
			name: 'home-sante-enfant',
			component: HomeSanteEnfant,
			props: (route) => ({id : route.params.id, jsonenfants : route.params.enfants, moisSel:route.query.moisSel})
		},
		{
			path: '*', // Everything that doesn't match a route
			name: 'notFound',
			component: () => import(/* webpackChunkName: "not-found" */ './views/NotFound.vue')
		}
	],
	// Native-like scroll behavior
	scrollBehavior(to, from, savedPosition) {
		// If there is an hash, this is an anchor, so scroll to it
		if (to.hash) {
			return {
				selector: to.hash
			};
		} else {
			// Else simulate browser behavior by returning to the previous position, or fallback to top
			if (savedPosition) {
				return savedPosition;
			} else {
				return { x: 0, y: 0 };
			}
		}
	}
});

router.beforeEach((to, from, next) => {
	// Resolve translations before each navigation
	const lang = i18n.locale;
	loadLanguageAsync(lang).then(() => next());
	// Change url in header
	if (to.path.indexOf('sante-enfant') != -1) {
		store.dispatch('home/updateRoutename', 'sante-enfant-accueil')
	} else {
		store.dispatch('home/updateRoutename', 'home')
	}
});

export default router;
